import { createContext } from 'react';
import { SupabaseClient } from '@supabase/supabase-js';
import { User } from '@supabase/supabase-js';
import { supabase } from '@/services/auth';
import { UserDetails } from '@/services/supabase-types';

interface UserContextType {
  user: User | null;
  supabase: SupabaseClient;
  /** null while signed out, while loading, or when /api/user failed. */
  userDetails: UserDetails | null;
  refreshUserDetails?: () => Promise<void>;
  /**
   * False only until the browser session has been read on mount (server render and
   * hydration). Once true, `user === null` really means signed out.
   */
  authReady?: boolean;
  /** True while a signed-in user's details are being fetched for the first time. */
  userDetailsLoading?: boolean;
  /**
   * True once the server-side auth cookie (/api/auth) belongs to the current user.
   * Cookie-authenticated API calls (claim, vectorize) made before this is true get 401.
   */
  authSynced?: boolean;
}

const Context = createContext<UserContextType>({
  user: null,
  supabase: supabase,
  userDetails: null,
  refreshUserDetails: async () => {},
  authReady: false,
  userDetailsLoading: false,
  authSynced: false,
});

export default Context;
